export default __webpack_public_path__ + "static/media/logo.cae0f84d.svg";